import { createStore } from '../helpers/state'

const initialState = {
}

export default createStore(initialState)
